export let footerStyle = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '100%',
  height: '10rem',
  backgroundColor: '#424242',
  borderTop: '2px solid #353535',
  color: '#fbfdff',
  flexShrink: '0'
};

export let lwtLinkContainerStyle = {
  marginBottom: '1rem'
};

export let lwtLinkStyle = {
  fontSize: '1.5rem',
  color: 'white',
  textDecoration: 'none'
};

export let smallTextStyle = {
  marginBottom: '1rem',
  fontSize: '80%',
  color: '#b5b5b5'
};

export let smallLinkStyle = {
  color: 'white',
  textDecoration: 'none'
};
